import {Modal} from "flowbite-react";
import {HiOutlineExclamation} from "react-icons/hi";
import CustomButton from "../../../components/common/CustomButton";
import React from "react";
import {useSelector} from "react-redux";
import {useProjectService} from "../../../services";

interface ResetWarningModalProps {
  showResetWarningModal: boolean;
  setShowResetWarningModal: (showResetWarningModal: boolean) => void;
  onRefresh: () => void;
}

const ResetWarningModal: React.FC<ResetWarningModalProps> = ({showResetWarningModal, setShowResetWarningModal, onRefresh}) => {
  const {
    sendSimulationReset,
  } = useProjectService();

  const {
    currentEntityId,
    simulation
  } = useSelector((state: any) => state.timeline);

  const handleResetConfirm = async () => {
    setShowResetWarningModal(false);
    if (currentEntityId) {
      await sendSimulationReset(currentEntityId, simulation);
      onRefresh();
    }
  };

  return (
    <Modal show={showResetWarningModal} onClose={() => setShowResetWarningModal(false)} className="h-[100vh] z-[9999]">
      <Modal.Header>Reset</Modal.Header>
      <Modal.Body>
        <div className="space-y-6">
          <div className="items-center text-center flex flex-col justify-center dark:text-white text-gray-600 text-base font-normal font-['Inter'] leading-snug">
            <HiOutlineExclamation className="text-6xl" />
            Reset<br/>
            You invoked reset Simulation<br/>
            Continuing will loose all your simulation work.<br/>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="items-center flex justify-center">
        <CustomButton className="bg-primary-light dark:bg-primary-dark hover:bg-primary-dark text-white" onClick={handleResetConfirm}>Ok</CustomButton>
        <CustomButton variant="cancel" onClick={() => setShowResetWarningModal(false)}>Cancel</CustomButton>
      </Modal.Footer>
    </Modal>
  );
}

export default ResetWarningModal;